// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7476e934","716":"462feb15"}[chunkId] + ".chunk.js";
};